/**
 * Shift select values. Component must set the shiftPressed using
 *
 * @keydown.shift="shiftPressed=true"
 * @keyup="shiftPressed=false"
 *
 * Next the application must call shiftSelectValues(values) and pass in values containing numeric array.
 *
 * NOTE: For some reason <v-select> does not emit @keyup.shift() event
 *
 */

export const shiftSelectMixin = {

    data() {
        return {
            shiftPressed: false,
            shiftSelectPreviousValues: [],
            shiftSelectLastSelectedItem: null,
        }
    },

    methods: {
        shiftSelectValues(values) {

            const selectedItem = this.arrayDiff(values, this.shiftSelectPreviousValues).pop();

            if (values.length > this.shiftSelectPreviousValues.length && this.shiftPressed && this.shiftSelectLastSelectedItem) {

                const rangeStart = selectedItem < this.shiftSelectLastSelectedItem ? selectedItem : this.shiftSelectLastSelectedItem;
                const rangeEnd = selectedItem < this.shiftSelectLastSelectedItem ? this.shiftSelectLastSelectedItem : selectedItem;

                for (let i = rangeStart; i < rangeEnd; i++) {
                    if (!values.includes(i)) {
                        values.push(i);
                    }
                }
            }

            this.shiftSelectLastSelectedItem = selectedItem;
            this.shiftSelectPreviousValues = values;
        },
    },
};

